import React, { useState, useEffect } from 'react';
import styles from './EasterEgg.module.css';

const EasterEgg = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleEasterEgg = () => {
      setIsVisible(true);
      
      // Log to console for developers
      console.log('%c🚀 EASTER EGG FOUND! 🚀', 'font-size: 20px; color: #00BCD4; font-weight: bold;');
      console.log('%cWelcome, fellow developer!', 'font-size: 14px; color: #FF6B35;');
      console.log('%cYou understand that data flows through ports.', 'font-size: 12px; color: #4DD0E1;');
      console.log('%c', 'font-size: 10px;');
      console.log(
        '%c' +
        '  _  ___ _                               \n' +
        ' | |/ (_) | ___  _ __   _____   ____ _  \n' +
        ' | \' /| | |/ _ \\| \'_ \\ / _ \\ \\ / / _` | \n' +
        ' | . \\| | | (_) | | | | (_) \\ V / (_| | \n' +
        ' |_|\\_\\_|_|\\___/|_| |_|\\___/ \\_/ \\__,_| \n' +
        '                                         ',
        'font-family: monospace; color: #00BCD4;'
      );
      console.log('%cWe\'re always looking for talented developers. Interested? hello@kilonovatech.co.za', 'font-size: 12px; color: #64748B;');
    };

    document.addEventListener('easterEggFound', handleEasterEgg);

    return () => {
      document.removeEventListener('easterEggFound', handleEasterEgg);
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className={styles.overlay} onClick={handleClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={handleClose}>
          ✕
        </button>
        
        <div className={styles.content}>
          <div className={styles.icon}>🎉</div>
          <h2 className={styles.title}>Easter Egg Found!</h2>
          <p className={styles.subtitle}>Welcome, Fellow Developer</p>
          
          <div className={styles.message}>
            <p>
              You found it! You understand that <strong>data flows through ports</strong> 
              but never leaves the machine.
            </p>
            <p>
              At Kilonova Technologies, we believe in the power of clean code, 
              thoughtful architecture, and elegant solutions. Just like this easter egg, 
              we hide <strong>quality</strong> in every detail.
            </p>
          </div>

          <div className={styles.codeBlock}>
            <code>
              const developer = &#123;<br />
              &nbsp;&nbsp;curiosity: 'high',<br />
              &nbsp;&nbsp;attention_to_detail: 'excellent',<br />
              &nbsp;&nbsp;status: 'easter_egg_hunter'<br />
              &#125;;
            </code>
          </div>

          <div className={styles.callout}>
            <p className={styles.calloutText}>
              💼 <strong>We're hiring!</strong> If you're passionate about building 
              great software, we'd love to hear from you.
            </p>
            <a href="mailto:hello@kilonovatech.co.za" className={styles.contactLink}>
              hello@kilonovatech.co.za
            </a>
          </div>

          <div className={styles.footer}>
            <p>Check your console for a surprise 👀</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EasterEgg;